import React from 'react';
import KeyBoardgrayIcon from '../../images/keyboardgray.png';
import Keyboard from '../modal/KeyBoard';
import Modal from 'react-bootstrap/Modal'

class RelativeSearchBar extends React.Component{
    
    state = { word: '' };
    state = { modalshow: false };
    state = { selectionStart : 0 };
    state = { selectionEnd : 0 };

    constructor(props) {
        super(props)
        this.state = { value: 0 }
        //this.onTextChange = this.onTextChange.bind(this)
    }
    
    onTextChange = event=> {
        var value = event.target.value;
        this.setState({ word:value }, () => {})

        if (!this.state.modalshow)
        {
            this.setState({selectionStart : event.target.selectionStart},()=>{});
            this.setState({selectionEnd : event.target.selectionEnd},()=>{});
        }

        this.props.onChange(this.props.id,event.target.value);
    }

    onTextKeyPress = event => {
        if ((event.nativeEvent.key === "Enter")&&(this.state.word)) {
            event.preventDefault();
            this.onSearchButtonClick(event);
        }
        this.setState({selectionStart : event.target.selectionStart});
        this.setState({selectionEnd : event.target.selectionEnd});
    }

    onTextClick = event =>{
        this.setState({modalshow:false})
        this.setState({selectionStart : event.target.selectionStart});
        this.setState({selectionEnd : event.target.selectionEnd});
    }

    onKeyboardButtonClick = (event) =>{
        event.preventDefault();
        if (!this.state.selectionStart)
        {
            this.setState({selectionStart : event.target.selectionStart});
            this.setState({selectionEnd : event.target.selectionStart});
        }
        this.setState({modalshow:!this.state.modalshow});
    }

    onVirtualKeyBoardTyped = input =>{
        const inputed=  (
                            ((this.state.word)&&(this.state.word.length>0))
                            ?
                            this.state.word.substring(0,this.state.selectionStart)
                            + input
                            + this.state.word.substring(this.state.selectionEnd,this.state.word.length)
                            :
                            input
                        )   
        this.setState({selectionStart : this.state.selectionStart+input.length});
        this.setState({selectionEnd : this.state.selectionStart});
        this.setState({ word:inputed }, () => {})
    }

    render(){
        return (
            <div className="SearchBar">
                <div className={this.props.className}>
                    <input 
                        id={this.props.id}
                        type="text" 
                        className={this.props.ShowInClass}
                        placeholder={this.props.PlaceHolder}
                        required="required" 
                        value={this.state.word || ''} 
                        onChange={this.onTextChange}
                        onKeyPress={this.onTextKeyPress}
                        onClick={this.onTextClick}
                        dir={this.props.ShowInClass==="farsi"?"rtl":"ltr"}
                    />
                    <input  className="keyboard" type="image" alt="KB" src={KeyBoardgrayIcon} onClick={this.onKeyboardButtonClick} />
                    <Modal
                        show={this.state.modalshow}
                        onHide={() => this.setState({modalshow: false})}
                        dialogClassName="modal-content-KB"
                        aria-labelledby="example-custom-modal-styling-title"
                        centered
                    >
                        <Modal.Body>
                            <Keyboard input={this.state.word} layout={this.props.ShowInClass} onVirtualKeyBoardTyped={this.onVirtualKeyBoardTyped}/>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default RelativeSearchBar;